
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25.14 20.17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Laag 2"}},[_c('path',{attrs:{"d":"M24.73 2l-.84-.91-.56-.65a1.32 1.32 0 00-2 0L9.2 13.52 3.79 7.66a1.33 1.33 0 00-2 0l-.69.74-.72.78a1.59 1.59 0 000 2.12l7.8 8.45a1.34 1.34 0 001.76.19 1.57 1.57 0 00.24-.21L24.73 4.09a1.6 1.6 0 000-2.13","fill":"#fff","data-name":"Laag 1"}})])])
          )
        }
      }
    